import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { StaffAvailability, UrlParams } from 'types';
import { client } from 'utils/api-client';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface UseStaffAvailabilityListProps {
  staffId: string | undefined;
  limit?: string;
  offset?: string;
}

export default function useStaffAvailabilityList({
  staffId,
  limit = '20',
  offset = '0',
}: UseStaffAvailabilityListProps): UseQueryResult<{ data: StaffAvailability[] }> {
  const queryFn = ({
    pageParam = { limit, offset },
  }: QueryKeyType): Promise<AxiosResponse<StaffAvailability[]>> => {
    const params = pageParam;
    if (staffId) {
      params.staff_id = staffId;
    }

    return client.get(`staff-availability/auto_complete/`, {
      params,
    });
  };

  return useQuery(['staff-availability'], queryFn, {
    enabled: !!staffId,
  });
}
